import $ from 'jquery';
import React from 'react';
import OptionPopupView from "views/common/OptionPopupView";
import { createRoot } from "react-dom/client";
import { WorkspaceMembersContent } from '../../components/workspace/WorkspaceMembersContent';

const WorkspaceMembersPopupView = OptionPopupView.extend({

    "pageName": "Workspace Members Popup",

    initialize: function(options) {
        this._members = options.members;
        this._isOwnerOrAdmin = options.isOwnerOrAdmin;
        this._seatLimit = options.seatLimit != null ? options.seatLimit : null;
        this._seatUsed = options.seatUsed || 0;
        this._mode = options.mode === "invite" ? "invite" : "manage";
        this._onInvite = options.onInvite;
        this._onRemove = options.onRemove;
        this._onSetRole = options.onSetRole;
        this._onSetAdmin = options.onSetAdmin;
        this._i18nModule = options.i18nModule;
        this._reactRoot = null;

        // Create content container for React component
        this.contentContainer$el = $('<div class="workspace-members-popup-content"></div>');
        this.contentContainer$el.css("width", "calc(100% - 40px)");
        this.contentContainer$el.css("max-width", this._mode === "invite" ? "460px" : "600px");

        // Configure OptionPopupView
        const contentView = {};
        contentView.$el = this.contentContainer$el;

        const viewOptions = {
            contentView: contentView,
            contentPosition: "text-not-white",
            addContentAfterEnhancement: true,
            displayTitle: false,
            id: "WorkspaceMembersPopup"
        };

        OptionPopupView.prototype.initialize.call(this, viewOptions);
    },

    onPopupClosed: function() {
        if (this._reactRoot) {
            this._reactRoot.unmount();
            this._reactRoot = null;
        }
    },

    updateMembers: function(members, seatLimit, seatUsed) {
        this._members = members;
        if (seatLimit !== undefined) {
            this._seatLimit = seatLimit;
        }
        if (seatUsed !== undefined) {
            this._seatUsed = seatUsed;
        }
        this._renderReactComponent();
    },

    onInviteTriggered: async function(email, role) {
        if (this._onInvite) {
            await this._onInvite(email, role);
        }
    },

    onRemoveTriggered: async function(memberRecordId) {
        if (this._onRemove) {
            await this._onRemove(memberRecordId);
        }
    },

    onSetRoleTriggered: async function(memberRecordId, newRole) {
        if (this._onSetRole) {
            await this._onSetRole(memberRecordId, newRole);
        }
    },

    onSetAdminTriggered: async function(memberRecordId, isAdmin) {
        if (this._onSetAdmin) {
            await this._onSetAdmin(memberRecordId, isAdmin);
        }
    },

    onCancelTriggered: function() {
        this.close();
    },

    _renderReactComponent: function() {
        // Unmount existing component if any
        if (this._reactRoot) {
            this._reactRoot.unmount();
        }

        // Create new React root and render component
        const root = createRoot(this.contentContainer$el.get(0));

        root.render(
            React.createElement(WorkspaceMembersContent, {
                members: this._members,
                isOwnerOrAdmin: this._isOwnerOrAdmin,
                seatLimit: this._seatLimit,
                seatUsed: this._seatUsed,
                mode: this._mode,
                onInvite: this.onInviteTriggered.bind(this),
                onRemove: this.onRemoveTriggered.bind(this),
                onSetRole: this.onSetRoleTriggered.bind(this),
                onSetAdmin: this.onSetAdminTriggered.bind(this),
                onClose: this.onCancelTriggered.bind(this),
                i18nModule: this._i18nModule
            })
        );

        this._reactRoot = root;
    },

    addReactWidget: function() {
        this._renderReactComponent();
    },

    onAfterPageShow: function() {
        // Render React component after popup is shown
        this.addReactWidget();
    },

    afterRender: function() {
        OptionPopupView.prototype.afterRender.call(this);
    }
});

export default WorkspaceMembersPopupView;
